import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';
import { Project } from '../../model/project';
import { ProjectService } from '../project.service';
import { Questionnaire } from '../../model/questionnaire';
import {Terminal} from '../../model/terminal';
import {FormControl} from '@angular/forms';
import {StatusMsg} from '../../model/status/StatusMsg';
import {Json2TypescriptUtil} from '../../util/json2TypescriptUtil';
import {TerminalUtil} from '../../util/terminalUtil';


@Component({

    selector: 'create-questionnaire-dialog',
    styles: [
        `
.modal-dialog {
    width:50%;
    margin:auto;
}

.modal-header{
    background-color:dodgerblue;
    color:antiquewhite;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}
.modal-content{
    border-top-right-radius: 18px;
    border-top-left-radius: 18px;
}

#userField.ng-invalid,#passField.ng-invalid {
    border: 2px solid #a94442;
}
.ng-valid[required], .ng-valid.required  {
    border: 2px solid #42A948; /* green */
}

.questionnaireWindow{ height:30px;}
.closeX{color:azure;size:25px;}
.btn-danger{background-color: red;border-style: solid;border-color: white;border-width:2px;}

            /*new css*/

.modal-title{margin-top: -5px;}
.closeBtnH4{margin-top:-5px;margin-right: -8px;}
.appWindow {
    height: 35px;
}
.clientRow{background-color: #D0DFFE;}

.led{width:22px;}

.tableHeader{ background-image: url("../../../assets/images/blueBack.jpg");}
th{color:#ffffff;text-align: center;}

.modalBodyContainer{
  background-color:  #ECE8E5;
}

.modal-footer{background-color: #ECE8E5;border-top: groove;}
.modal-body {
    width: 100%;
    overflow-y: auto;
}
.modal-body thead {
    position: sticky;
    top:0;
}
::-webkit-scrollbar {
    width: 14px;
    height: 5px;
    background-color: #F5F3F0;
}
::-webkit-scrollbar-thumb {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color:#BACEFF;
    -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}
::-webkit-scrollbar-button {
    width: 14px;
    height: 14px;
    display: none;
}
::-webkit-scrollbar-corner {
    background-color: transparent;
}

.modal-dialog {
    margin: 50px auto auto;
    background-color: #0064FE;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.modal-header {
    height:56px;
    background-image: url("../../../assets/images/headerBack.jpg");
    color: antiquewhite;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.modal-content {
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    padding-left: 3px;
    padding-right: 3px;
    background-color: #0064FE;
    padding-bottom: 3px;
}

.closeX {
    color: white;
    size: 25px;
}

.btn-outline-danger {
    background-color: #d6462e;
    border-style: solid;
    border-color: white;
    border-width: 2px;
    padding: 0;
}

/* .btn-outline-danger:hover {
     width: 32px;
     background-image: url("../../../assets/images/closeBtnHovered.png");
 }*/

.closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

.closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}
        `
    ],

    template: `<div class="modal" [style.display]="hide ? 'none' : 'inline'" style="margin : 20px; ">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <img *ngIf="this.modalTitle!=null && this.modalTitle.includes('Questionnaire')" class="questionnaireWindow" src="../../../assets/images/googleForm.png">
                <img *ngIf="this.modalTitle!=null && this.modalTitle.includes('Terminal')" class="questionnaireWindow" src="../../../assets/images/windowsTablet.png">
              <h4 class="modal-title">{{modalTitle}}</h4>
              <!--<button (click)="hideDialog(); questionnaireForm.resetForm()" type="button" class="btn btn-danger" data-dismiss="modal" aria-label="Close">
                  <span class="closeX" aria-hidden="true"><i class="fas fa-times"></i></span>
              </button>-->
                <h4 class="closeBtnH4"><button (click)="hideDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                    <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                </button></h4>
            </div>
            <div class="modalBodyContainer">
            <form  accept-charset="UTF-8" name="questionnaireForm" (ngSubmit)="questionnaireForm.form.valid && createQuestionnaire() " #questionnaireForm="ngForm">
                <div class="modal-body">
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4">
                            <label>Title</label>
                        </div>
                        <div class="col-md-8" *ngIf="!(this.terminal)">
                            <input type="text" [placeholder]="placeHolderText" name="questionnaireTitle" class="form-control" [(ngModel)]="_questionnaire.name" #questionnaireTitle="ngModel"
                                required />
                            <div *ngIf="questionnaireTitle.errors && (questionnaireTitle.dirty || questionnaireTitle.touched)"
                                class="alert alert-danger">
                                <div [hidden]="!questionnaireTitle.errors.required">
                                    Title is required
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8" *ngIf="this.terminal">
                            <input type="text" [placeholder]="placeHolderText" name="terminalTitle" class="form-control" [(ngModel)]="_terminal.name" #terminalTitle="ngModel"
                                   required />
                            <div *ngIf="terminalTitle.errors && (terminalTitle.dirty || terminalTitle.touched)"
                                 class="alert alert-danger">
                                <div [hidden]="!terminalTitle.errors.required">
                                    Title is required
                                </div>
                            </div>
                        </div>
                    </div>
                  <div class="row" style="margin-top:20px;">
                    <div class="col-md-4" *ngIf="this.terminal">
                      <label>Terminal Type</label>
                    </div>
                    <div class="col-md-8" *ngIf="this.terminal">
                      <ngx-select
                        [allowClear]="true"
                        [items]="this.terminalTypeList"
                        [formControl]="selectControl"
                      ></ngx-select>
                      <div *ngIf="this.showErrorSelect"
                           class="alert alert-danger">
                        <div>
                          A Terminal Type is required.
                        </div>
                      </div>
                    </div>
                  </div>
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4" *ngIf="this.terminal">
                            <label>Questionnaire to link</label>
                        </div>
                        <div class="col-md-8" *ngIf="this.terminal">
                            <ngx-select
                                    [allowClear]="true"
                                    [items]="this.questionnaireList"
                                    [formControl]="selectControl"
                            ></ngx-select>
                            <div *ngIf="this.showErrorSelect"
                                 class="alert alert-danger">
                                <div>
                                    A questionnaire is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top:8px;" *ngIf="this.terminal">
                        <div class="col-md-4">
                            <label>{{'username'| translate}}</label>
                        </div>
                        <div class="col-md-8">
                            <input id="userField" type="text"  name="username" class="form-control" [(ngModel)]="_terminal.username" #username="ngModel"
                                   required />
                            <div *ngIf="username.errors && (username.dirty || username.touched)"
                                 class="alert alert-danger">
                                <div [hidden]="!username.errors.required">
                                    Username is required
                                </div>
                            </div>
                            <div *ngIf="!userVerify(username.value)"
                                 class="alert alert-danger">
                                <div [hidden]="userVerify(username.value)">
                                    Username exists already
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top:20px;" *ngIf="this.terminal">
                        <div class="col-md-4">
                            <label>{{'password'| translate}}</label>
                        </div>
                        <div class="col-md-8">
                            <input id="passField" type="text"  name="password" class="form-control" [(ngModel)]="_terminal.password" #password="ngModel"
                                   required />
                            <div *ngIf="password.errors && (password.dirty || password.touched)"
                                 class="alert alert-danger">
                                <div [hidden]="!password.errors.required">
                                    password is required
                                </div>
                            </div>
                            <div *ngIf="!passwordVerify(password.value)"
                                 class="alert alert-danger">
                                <div [hidden]="!passwordVerify(password.value)">
                                    Password exists already
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- footer-->
                <div class="modal-footer ">
                    <button type="button" class="btn btn-primary clickable hand" id="submit" type="submit">{{'save'|translate}}</button>
                </div>
            </form>
            </div>
        </div>
    </div>
</div>
    `

})
export class CreateQuestionnaireComponent implements OnInit {

    @Input('terminal')terminal = false;
    @Input('hide') hide = true;
    @Input('project') project: Project;
    @Input('modalTitle')modalTitle = '';
    @Input('placeholderText')placeHolderText:string;

    @Output() NewQuestionnaire: EventEmitter<any> = new EventEmitter();
    @Output() CancelQuestionnaire: EventEmitter<any> = new EventEmitter();
    @Output() StatusMessage:EventEmitter<any> = new EventEmitter();
    private _questionnaire: Questionnaire = new Questionnaire();
    private _terminal: Terminal = new Terminal();
    private _questionnairePlaceHolderText ='Questionnaire To Link To The Terminal';  // don't forget to translate the strings to support internalization
    private questionnaireList:Array<string>;
    private terminalTypeList:Array<string>;
    errorMessage: string;

    private selectedQuestionnaireID =0;

    private terminalType ='';

    private showErrorSelect=false;
    private selectionInvalid = true;

    private terminalsArray:Terminal[]=[];

    public selectControl = new FormControl();

    constructor(private _projectService: ProjectService) {



    }

    ngOnInit():void {
        this.questionnaireList = [];
      //  this.questionnaireList.push("Select a questionnaireProject");
        for(const item of this.project.questionnaires) {
            this.questionnaireList.push(item.name);
        }

      this.selectControl.valueChanges.subscribe(value => this.selected(value));

    }


    userVerify(value:string):boolean {
        // Verify if the username password pair exists or not
        for(const item of this.terminalsArray) {
            if (item.username === value) {
                return false;
            }
        }

        return true;
    }

    passwordVerify(value:string):boolean {
        // Verify if the username password pair exists or not
        for(const item of this.terminalsArray) {
            if (item.password === value) {

                return false;
            }
        }

        return true;
    }

    createQuestionnaire() {

        this._questionnaire.projectId = Number(this.project.id);
        const status = new StatusMsg();
        if(this.terminal) {
            if(!this.selectionInvalid) {
                this._projectService.createTerminal(this._terminal,this.selectedQuestionnaireID)
                    .subscribe((newTerminal:Terminal) => {
                            console.log('Newly created terminal =>' +JSON.stringify(newTerminal));
                            if(newTerminal != null) {
                                this.hideDialog();
                                this.NewQuestionnaire.emit(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(newTerminal,Terminal));// new Terminal(newTerminal));
                            } else if(newTerminal == null) {
                                this.hideDialog();
                                this.NewQuestionnaire.emit(null);
                            }
                        },
                        error => {
                                        status.httpStatusCode = error.status;
                                        status.statusMsg = 'Not allowed to use an existing Username and password combination.';
                                        this.StatusMessage.emit(status);
                                        console.log('Error create client');});
            } else {
                this.showErrorSelect = true;
            }
        } else {
            this._projectService.createQuestionnaire(this._questionnaire)
                .subscribe(data => {
                    if(data === 100) {
                        this.hideDialog();
                        this.NewQuestionnaire.emit(200);
                    } else if(data === 102) {
                        this.hideDialog();
                        this.NewQuestionnaire.emit(data);
                    }
                },
                error => console.log('Error create client'));
        }
    }


    hideDialog() {
        this._questionnaire = new Questionnaire();
        this.hide = !this.hide;
    }

    selected(value:any) {
        if(value !== '') {

            for(const item of this.project.questionnaires) {
                if(item.name === value) {
                    this.selectedQuestionnaireID = item.id;
                    this._terminal.associatedQuestionnaireId =  item.id;
                }
            }

            if(this.terminalTypeList.includes(value)) {
              this._terminal.type = TerminalUtil.extractTerminal(value);
            }



            this.showErrorSelect = false;
            this.selectionInvalid = false;
        }
    }

    refreshValue(value:any):void {

    }

    resetFields():void {
        this._terminal.name='';
        this._terminal.password='';
        this._questionnaire.name='';
    }


    generateQuestionnaireDropDownList() {

        this.questionnaireList = [];
        //  this.questionnaireList.push("Select a questionnaireProject");
        for(const item of this.project.questionnaires) {
            this.terminalsArray.concat(item.terminals);
            this.questionnaireList.push(item.name);
        }

    }

    generateTerminalTypeDropDown() {
        this.terminalTypeList = [];
        this.terminalTypeList.push('iBrand Android');
        this.terminalTypeList.push('iBrand Windows');
        this.terminalTypeList.push('Web');
    }
}
